import { render } from "./ChatsQuotes.vue?vue&type=template&id=9b48ac8e&scoped=true&ts=true"
import script from "./ChatsQuotes.vue?vue&type=script&lang=ts"
export * from "./ChatsQuotes.vue?vue&type=script&lang=ts"

import "./ChatsQuotes.vue?vue&type=style&index=0&id=9b48ac8e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b48ac8e"]])

export default __exports__